// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static MessageLogs = class {
        static _ = 'Administration.MessageLogs';

        static List = 'Administration.MessageLogs.List';
    };

    static User = class {
        static _ = 'Administration.User';

        static ViewAll = 'Administration.User.ViewAll';
        static ViewOwn = 'Administration.User.ViewOwn';
        static Edit = 'Administration.User.Edit';
        static Create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static ViewAll = 'Administration.Role.ViewAll';
        static ViewOwn = 'Administration.Role.ViewOwn';
        static Edit = 'Administration.Role.Edit';
        static Create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static ViewAll = 'Administration.Organization.ViewAll';
        static ViewOwn = 'Administration.Organization.ViewOwn';
        static Edit = 'Administration.Organization.Edit';
        static Create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static View = 'Administration.Settings.View';
        static Edit = 'Administration.Settings.Edit';
    };

}

export class VesselAnnouncementPermissions {
    static _ = 'VesselAnnouncement';

    static Default = class {
        static _ = 'VesselAnnouncement.Default';

        static List = 'VesselAnnouncement.Default.List';
        static View = 'VesselAnnouncement.Default.View';
        static Create = 'VesselAnnouncement.Default.Create';
        static Edit = 'VesselAnnouncement.Default.Edit';
    };

}

export class PortPlanRevisionPermissions {
    static _ = 'PortPlanRevision';

    static Default = class {
        static _ = 'PortPlanRevision.Default';

        static List = 'PortPlanRevision.Default.List';
        static View = 'PortPlanRevision.Default.View';
        static Create = 'PortPlanRevision.Default.Create';
        static Edit = 'PortPlanRevision.Default.Edit';
    };

}

export class BunkerListPermissions {
    static _ = 'BunkerList';

    static Default = class {
        static _ = 'BunkerList.Default';

        static List = 'BunkerList.Default.List';
    };

}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Action = class {
        static _ = 'CodeList.Action';

        static Create = 'CodeList.Action.Create';
        static Delete = 'CodeList.Action.Delete';
        static Edit = 'CodeList.Action.Edit';
    };

    static View = class {
        static _ = 'CodeList.View';

        static Item = 'CodeList.View.Item';
        static List = 'CodeList.View.List';
    };

}

export class EventEvidencePermissions {
    static _ = 'EventEvidence';

    static Default = class {
        static _ = 'EventEvidence.Default';

        static List = 'EventEvidence.Default.List';
    };

}

export class FaqPermissions {
    static _ = 'Faq';

    static Action = class {
        static _ = 'Faq.Action';

        static Save = 'Faq.Action.Save';
        static Delete = 'Faq.Action.Delete';
    };

    static View = class {
        static _ = 'Faq.View';

        static List = 'Faq.View.List';
    };

}

export class MonthlyPlanPermissions {
    static _ = 'MonthlyPlan';

    static Default = class {
        static _ = 'MonthlyPlan.Default';

        static List = 'MonthlyPlan.Default.List';
        static View = 'MonthlyPlan.Default.View';
        static Create = 'MonthlyPlan.Default.Create';
        static Edit = 'MonthlyPlan.Default.Edit';
    };

}

export class ReportsPermissions {
    static _ = 'Reports';

    static MonthlyPlans = class {
        static _ = 'Reports.MonthlyPlans';

        static List = 'Reports.MonthlyPlans.List';
    };

    static EsiPoints = class {
        static _ = 'Reports.EsiPoints';

        static List = 'Reports.EsiPoints.List';
    };

    static Bunkers = class {
        static _ = 'Reports.Bunkers';

        static List = 'Reports.Bunkers.List';
    };

    static Movements = class {
        static _ = 'Reports.Movements';

        static List = 'Reports.Movements.List';
    };

    static VesselsOnAnchor = class {
        static _ = 'Reports.VesselsOnAnchor';

        static List = 'Reports.VesselsOnAnchor.List';
    };

    static Protests = class {
        static _ = 'Reports.Protests';

        static List = 'Reports.Protests.List';
    };

    static Voyages = class {
        static _ = 'Reports.Voyages';

        static List = 'Reports.Voyages.List';
    };

    static AnchorVoyage = class {
        static _ = 'Reports.AnchorVoyage';

        static List = 'Reports.AnchorVoyage.List';
    };

    static VesselNumber = class {
        static _ = 'Reports.VesselNumber';

        static List = 'Reports.VesselNumber.List';
    };

}

export class NoticeBoardPermissions {
    static _ = 'NoticeBoard';

    static Action = class {
        static _ = 'NoticeBoard.Action';

        static Create = 'NoticeBoard.Action.Create';
        static Edit = 'NoticeBoard.Action.Edit';
    };

    static View = class {
        static _ = 'NoticeBoard.View';

        static Deactivated = 'NoticeBoard.View.Deactivated';
        static List = 'NoticeBoard.View.List';
    };

}

export class PilotagePlanPermissions {
    static _ = 'PilotagePlan';

    static Default = class {
        static _ = 'PilotagePlan.Default';

        static List = 'PilotagePlan.Default.List';
    };

}

export class ProtestPermissions {
    static _ = 'Protest';

    static Default = class {
        static _ = 'Protest.Default';

        static List = 'Protest.Default.List';
        static View = 'Protest.Default.View';
        static Create = 'Protest.Default.Create';
        static Edit = 'Protest.Default.Edit';
    };

}

export class VesselPermissions {
    static _ = 'Vessel';

    static Default = class {
        static _ = 'Vessel.Default';

        static List = 'Vessel.Default.List';
        static View = 'Vessel.Default.View';
        static Create = 'Vessel.Default.Create';
        static Edit = 'Vessel.Default.Edit';
    };

}

export class VesselVisitPermissions {
    static _ = 'VesselVisit';

    static Default = class {
        static _ = 'VesselVisit.Default';

        static List = 'VesselVisit.Default.List';
        static View = 'VesselVisit.Default.View';
        static Create = 'VesselVisit.Default.Create';
        static Edit = 'VesselVisit.Default.Edit';
    };

    static VesselVisitEvent = class {
        static _ = 'VesselVisit.VesselVisitEvent';

        static Create = 'VesselVisit.VesselVisitEvent.Create';
        static List = 'VesselVisit.VesselVisitEvent.List';
    };

    static VesselVisitBunker = class {
        static _ = 'VesselVisit.VesselVisitBunker';

        static Create = 'VesselVisit.VesselVisitBunker.Create';
        static List = 'VesselVisit.VesselVisitBunker.List';
    };

    static VesselVisitPilotage = class {
        static _ = 'VesselVisit.VesselVisitPilotage';

        static Create = 'VesselVisit.VesselVisitPilotage.Create';
        static List = 'VesselVisit.VesselVisitPilotage.List';
    };

    static VesselVisitCoLoader = class {
        static _ = 'VesselVisit.VesselVisitCoLoader';

        static Create = 'VesselVisit.VesselVisitCoLoader.Create';
        static List = 'VesselVisit.VesselVisitCoLoader.List';
    };

    static VesselVisitAdditionalService = class {
        static _ = 'VesselVisit.VesselVisitAdditionalService';

        static Create = 'VesselVisit.VesselVisitAdditionalService.Create';
        static List = 'VesselVisit.VesselVisitAdditionalService.List';
    };

    static VesselVisitAttachment = class {
        static _ = 'VesselVisit.VesselVisitAttachment';

        static Create = 'VesselVisit.VesselVisitAttachment.Create';
        static List = 'VesselVisit.VesselVisitAttachment.List';
    };

}


